export class ProcessType {
  static DEPART = "depart";
  static DEPART_BAILLEUR = "depart_bailleur";
}
